import { __rest } from "tslib";
import React from 'react';
import { ShowIcon, HideIcon } from '../../assets/svgs';
import { TertiaryButton } from '../Button';
import clsx from 'clsx';
import './SensitiveFieldWrapper.less';
const SensitiveFieldWrapper = (_a) => {
    var { inputId, children, onToggle, showContent, buttonLabelShow = 'Show', buttonLabelHide = 'Hide' } = _a, otherProps = __rest(_a, ["inputId", "children", "onToggle", "showContent", "buttonLabelShow", "buttonLabelHide"]);
    return (React.createElement("div", Object.assign({ className: clsx('kal-sensitive-form-field-container', showContent ? 'show' : 'hide') }, otherProps),
        children,
        React.createElement(TertiaryButton, { className: 'show-hide-button', onClick: onToggle, iconStart: showContent ? React.createElement(HideIcon, { "aria-hidden": true }) : React.createElement(ShowIcon, { "aria-hidden": true }), lowProfile: true, "aria-controls": inputId }, showContent ? buttonLabelHide : buttonLabelShow)));
};
export default SensitiveFieldWrapper;
//# sourceMappingURL=SensitiveFieldWrapper.js.map